import ReactDom from "react-dom";
import MilestoneChart from "./MilestoneChart.jsx";

export default function renderMilestoneCharts() {
  document.querySelectorAll(".js-milestone-chart-mount").forEach((mount) => {
    const datacenterData = JSON.parse(mount.getAttribute("data-model"));

    const showEventsRaw = mount.getAttribute("data-show-events");
    const showEvents = (showEventsRaw || "false").toLowerCase() === "true";

    const colors = JSON.parse(mount.getAttribute("data-colors"));

    ReactDom.render(
      <MilestoneChart
        showEvents={showEvents}
        colors={colors}
        {...datacenterData}
      />,
      mount,
    );
  });
}
